export function durationAsMinutesSeconds(duration: number) {
  const seconds = Math.floor(duration % 60);
  const minutes = Math.floor(duration / 60);

  // append 0 to seconds
  const formattedSeconds =
    seconds < 10 ? String(seconds).padStart(2, '0') : String(seconds);

  return {
    minutes,
    seconds: formattedSeconds,
  };
}

export function durationToPercentage({
  currentTime = 0,
  duration = 0,
}: {
  currentTime: number;
  duration: number;
}) {
  if (duration === 0) return 0;

  const percentagePosition = (100 * currentTime) / duration;
  return percentagePosition;
}
